import React from 'react';
import { SvgProp } from './types';

export const DeleteIcon: React.FC<SvgProp> = ({ onClick, width, height, fill }) => {
  return (
    <svg
      width={width ?? '13'}
      height={height ?? '15'}
      viewBox="0 0 13 15"
      fill={fill ?? 'none'}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83287 0.928589C8.11771 0.928663 8.3953 1.01835 8.62633 1.18496C8.85736 1.35156 9.03012 1.58663 9.12012 1.85687L9.48859 2.9643H11.7143C11.8943 2.9643 12.0669 3.0358 12.1941 3.16305C12.3214 3.29031 12.3929 3.46291 12.3929 3.64287C12.3929 3.82284 12.3214 3.99544 12.1941 4.1227C12.0669 4.24995 11.8943 4.32145 11.7143 4.32145H11.0357V12.4643C11.0357 13.0042 10.8213 13.522 10.4395 13.9038C10.0577 14.2855 9.53992 14.5 9.00002 14.5H3.57145C3.03154 14.5 2.51375 14.2855 2.13198 13.9038C1.75021 13.522 1.53573 13.0042 1.53573 12.4643V4.32145H0.85716C0.677192 4.32145 0.504595 4.24995 0.377338 4.1227C0.250081 3.99544 0.178589 3.82284 0.178589 3.64287C0.178589 3.46291 0.250081 3.29031 0.377338 3.16305C0.504595 3.0358 0.677192 2.9643 0.85716 2.9643H3.08287L3.45134 1.85687C3.54138 1.58652 3.71424 1.35137 3.94541 1.18476C4.17657 1.01815 4.45432 0.92852 4.73927 0.928589H7.83287ZM9.67859 4.32145H2.89287V12.4643C2.89287 12.6443 2.96437 12.8169 3.09162 12.9441C3.21888 13.0714 3.39148 13.1429 3.57145 13.1429H9.00002C9.17999 13.1429 9.35258 13.0714 9.47984 12.9441C9.6071 12.8169 9.67859 12.6443 9.67859 12.4643V4.32145ZM7.83287 2.28573H4.73859L4.51262 2.9643H8.05884L7.83287 2.28573Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};
